import React, {Component} from 'react'
import '../styles/_ListJobContainer.scss'
import ListJobPage from "./ListJobPage"

class ListJobContainer extends Component {
    render() {
        return (
            <div className="ListJobContainer">
                <ListJobPage/>
            </div>
        )
    }
}

export default ListJobContainer